import CircleCheck from '@/assets/icons/circle-check.svg?react';
import { cn } from '@/lib/utils';

type StepIconTopbarProps = {
  index: number;
  state: 'active' | 'disabled' | 'completed';
};

export const StepIconTopbar = ({ index, state, ...props }: StepIconTopbarProps) => {
  return (
    <div
      {...props}
      className={cn(
        'typo-secondary font-semibold border-2 border-primary rounded-full w-6 h-6 flex justify-center items-center mr-3',
        state === 'active' && 'border-primary text-primary',
        state === 'disabled' && 'border-disabled-text text-white-text bg-disabled-text',
        state === 'completed' && 'bg-primary text-text',
      )}
    >
      {state === 'completed' && <CircleCheck data-testid="step-icon-topbar-icon-completed" className="text-primary" />}
      {state !== 'completed' && index}
    </div>
  );
};
